import { Controller } from '@hotwired/stimulus'

const ANCHOR_CLASS =
  'article-heading-link not-prose inline-flex! ' +
  'align-baseline ml-[0.35em] size-[0.72em] duration-200 scale-90 ' +
  'opacity-0 group-hover/heading:opacity-100 ' +
  'group-hover/heading:scale-100 focus-visible:opacity-100 ' +
  'focus-visible:scale-100'

const ICON_WRAPPER_CLASS =
  'flex items-center justify-center fill-current size-full'

export default class extends Controller {
  static targets = ['iconTemplate']
  static values = { label: String }

  connect() {
    const baseUrl = window.location.origin + window.location.pathname

    this.element.querySelectorAll('h2, h3, h4, h5, h6').forEach(heading => {
      if (heading.querySelector('a.article-heading-link')) return

      const id = heading.id
      if (!id) return

      heading.classList.add('group/heading', 'cursor-pointer')

      heading.dataset.controller = [heading.dataset.controller, 'copy']
        .filter(Boolean)
        .join(' ')

      heading.dataset.action = [
        heading.dataset.action,
        'click->copy#copyValue:prevent'
      ]
        .filter(Boolean)
        .join(' ')

      heading.dataset.copyCopyStringValue = `${baseUrl}#${id}`
      heading.appendChild(this.buildAnchor(id))
    })
  }

  buildAnchor(id) {
    const anchor = document.createElement('a')
    anchor.href = `#${id}`
    anchor.className = ANCHOR_CLASS
    anchor.ariaLabel = this.labelValue
    anchor.dataset.copyTarget = 'copiedTooltipEl'

    const iconWrapper = document.createElement('icon')
    iconWrapper.className = ICON_WRAPPER_CLASS
    iconWrapper.innerHTML = this.iconTemplateTarget.innerHTML

    anchor.appendChild(iconWrapper)

    return anchor
  }
}
